import { PANEL_CATALOG } from "../config/panelCatalog";
import type { PanelPermission } from "../api/access";

export const NAV_PANEL_COUNT = PANEL_CATALOG.filter((p) => !p.feature).length;

export const enabledCount = (perms?: Record<string, PanelPermission>) =>
  PANEL_CATALOG.filter((p) => !p.feature && perms?.[p.key]?.visible).length;

export const blankPermissions = (
  existing?: Record<string, PanelPermission>
): Record<string, PanelPermission> => {
  const out: Record<string, PanelPermission> = {};
  for (const p of PANEL_CATALOG) {
    // forceView panels are always visible for every role; keep any Manage level
    // the profile already granted, but never let View be turned off.
    if (p.forceView) {
      out[p.key] = {
        visible: true,
        level: existing?.[p.key]?.level ?? p.defaultLevel ?? "view",
      };
      continue;
    }
    out[p.key] =
      existing?.[p.key] ?? {
        visible: p.defaultVisible ?? !!p.feature,
        level: p.defaultLevel ?? "view",
      };
  }
  return out;
};
